import * as Yup from "yup";

/**
 * Create a validation schema for the tag form.
 * @param tagNames A list of pre-exisiting tag names that's used to make sure a duplicate name is not valid.
 * @returns A validation schema for a tag.
 */
export const getValidationSchema = (tagNames: string[]) => {
    return Yup.object({
        tag: Yup.string().trim().required("Required").notOneOf(tagNames, "Duplicate Tag Name"),
        tagId: Yup.string().trim().nullable(),
        tagGroup: Yup.string(),
        tagGroupId: Yup.mixed().required("Required"),
    });
};
